import axios from "axios";
import { IDefaultService, IIndustry, IIndustryAliasSearchResult, IPaginatedResponse } from "../../types/types";

export const getDefaultIndustry = async (): Promise<IIndustry[]> => {
  try {
    const industriesRes = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get_all_industries`
    );
    return industriesRes.data.message;
  } catch (e) {
    console.error(e);
    return [];
  }
};

// Server-side search for industries
export const searchIndustries = async (
  q: string,
  options?: { limit?: number }
): Promise<IIndustry[]> => {
  try {
    const url = `${process.env.REACT_APP_SERVER_URL}/api/get_all_industries`;
    const params: { q: string; limit?: number } = { q: q?.trim() };
    if (options?.limit != null) params.limit = options.limit;
    const res = await axios.get(url, { params });
    return res.data?.message || [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getDefaultIndustryServices = async (
  industryId: number
): Promise<IDefaultService[]> => {
  try {
    const serviceResponse = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/get_default_services/${industryId}`
    );
    return serviceResponse.data.message;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const searchIndustryAliases = async (
  params: {
    industry_id: number;
    q: string;
    mode?: "auto" | "fuzzy" | "exact";
    threshold?: number;
    limit?: number;
    page?: number;
  }
): Promise<IPaginatedResponse<IIndustryAliasSearchResult>> => {
  const { industry_id, q, mode = "auto", threshold = 0.85, limit = 10, page = 1 } = params;
  try {
    const url = `${process.env.REACT_APP_SERVER_URL}/api/industry-alias`;
    const res = await axios.get<IPaginatedResponse<IIndustryAliasSearchResult>>(url, {
      params: { industry_id, q, mode, threshold, limit, page },
    });
    return res.data;
  } catch (e) {
    console.error(e);
    return { count: 0, next: null, previous: null, results: [] };
  }
};
